import React from 'react';

const SelectField = ({
    id,
    label,
    name,
    customClass,
    value,
    onChange,
    onBlur,
    error,
    touch,
    options,
}) => {
    return (
        <div>
            <label
                htmlFor={id}
                className={`block mt-2 text-sm capitalize font-medium text-gray-900 ${customClass}`}
            >
                {label}
            </label>
            <div>
                <select
                    id={id}
                    name={name}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    className="bg-gray-50 border capitalize border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-3"
                >
                    <option value="" disabled>
                        Choose a platform
                    </option>
                    {options?.data?.map((data, index) => (
                        <option
                            key={index}
                            value={data.name}
                            className="tracking-wide capitalize"
                        >
                            {data.name}
                        </option>
                    ))}
                </select>
                {error && touch ? (
                    <h1 className="text-xs text-red-600">{error}</h1>
                ) : null}
            </div>
        </div>
    );
};

export default SelectField;
